// extracted by mini-css-extract-plugin
export default {"loginCard":"login_loginCard__o6Vbn","loginText":"login_loginText__1j3Zi","loginButton":"login_loginButton__fEOVi"};